<template>
  <div>
    <Modal v-model="modalValue" title="证书字段列表" width="900" :footer-hide="type == 1" @on-cancel="modalCancel">
      <div class="search">
        <div>
          <Input
            v-model="search.search"
            placeholder="请输入字段名称"
            style="width: 200px; margin-right: 10px"
            icon="ios-search"
          ></Input>
          <Select style="width: 200px; margin-right: 10px" placeholder="请选择字段状态" v-model="search.status">
            <Option label="全部" value=""></Option>
            <Option label="有效" value="1"></Option>
            <Option label="无效" value="0"></Option>
          </Select>
          <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
          <Button style="width: 90px; margin-left: 10px" @click="clearFn">清空</Button>
        </div>
        <Button type="primary" icon="ios-add" @click="diyDom.showModal = true">添加</Button>
      </div>
      <div class="table">
        <Table border :loading="diyDom.tabLoading" :columns="diyData.columns" :data="apiData.tableList">
          <template slot="footer">
            <Page
              :total="apiData.total"
              show-total
              :page-size="apiData.per_page"
              :current="search.page"
              class-name="footer-page"
              @on-change="pageChange"
            ></Page>
          </template>
        </Table>
      </div>
      <div slot="footer">
        <Button @click="modalCancel">取消</Button>
        <Button type="primary" @click="modalConfirm">确认</Button>
      </div>
    </Modal>
    <add-field
      v-model="diyDom.showModal"
      :id="diyData.id"
      :isEdit="diyDom.isEdit"
      @on-success="getTableList"
    ></add-field>
  </div>
</template>

<script>
  import * as apiCertificates from '@/api/certificates'
  import addField from './add-field.vue'
  export default {
    components: {
      addField,
    },
    name: 'license-field',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      // 类型，1增删改查，2选择字段
      type: {
        type: [String, Number],
        default: '1',
      },
      // 选择的证书字段
      list: {
        type: [Array],
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        query: {},
        search: {
          search: '',
          status: '',
          page: 1,
        },
        diyDom: {
          tabLoading: false,
          showModal: false,
          isEdit: false,
        },
        diyData: {
          selectList: [], // 选择项
          id: '',
          columns: [
            {
              title: 'ID',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '字段名称',
              key: 'title',
            },
            {
              title: '状态',
              key: 'status_label',
            },
            {
              title: '操作',
              fixed: 'right',
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                        display: this.type == 1 ? 'inline' : 'none',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.isEdit = true
                          this.diyDom.showModal = true
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: 'red',
                        display: this.type == 1 ? 'inline' : 'none',
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '请确认是否删除当前数据？',
                            onOk: () => {
                              apiCertificates.apiCertificatesFieldsDetele(params.row.id).then(res => {
                                this.$Message.success('已删除')
                                this.getTableList()
                              })
                            },
                          })
                        },
                      },
                    },
                    '删除'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                        display: this.type == 2 ? 'inline' : 'none',
                      },
                      on: {
                        click: () => {
                          let findIndex = this.diyData.selectList.findIndex(item => item.id == params.row.id)
                          if (findIndex != -1) {
                            this.diyData.selectList.splice(findIndex, 1)
                          } else {
                            this.diyData.selectList.push(params.row)
                          }
                        },
                      },
                    },
                    this.diyData.selectList.find(item => item.id == params.row.id) ? '取消选中' : '选中'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.diyDom.tabLoading = true
        apiCertificates
          .apiCertificatesFieldsList({ ...this.search, is_default: this.type == 2 ? 0 : '' })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.per_page = meta.pagination.per_page
            this.apiData.total = meta.pagination.total

            // 选中项赋值
            this.diyData.selectList = this.list
          })
          .finally(() => (this.diyDom.tabLoading = false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        this.search = {
          search: '',
          status: '',
          page: 1,
        }
        this.getTableList()
      },
      modalCancel() {
        this.modalValue = false
        this.diyData.selectList = []
      },
      // 选中字段后
      modalConfirm() {
        this.$emit('on-change',this.diyData.selectList)
        this.modalCancel()
      }
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val) {
          this.getTableList()
        }
      },
      'diyDom.showModal'(val) {
        if (!val) {
          this.diyDom.isEdit = false
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
</style>
